import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface NotificationPrefs {
  inbound_call: boolean
  task_assigned: boolean
  lead_assigned: boolean
  task_overdue: boolean
}

interface NotificationStore {
  permission: NotificationPermission
  prefs: NotificationPrefs
  lastSeenId: number
  setPermission: (p: NotificationPermission) => void
  setPref: (type: keyof NotificationPrefs, enabled: boolean) => void
  setLastSeenId: (id: number) => void
  requestPermission: () => Promise<void>
}

const getInitialPermission = (): NotificationPermission => {
  if (typeof window !== 'undefined' && 'Notification' in window) {
    return Notification.permission
  }
  return 'default'
}

export const useNotificationStore = create<NotificationStore>()(
  persist(
    (set) => ({
      permission: getInitialPermission(),
      prefs: {
        inbound_call: true,
        task_assigned: true,
        lead_assigned: true,
        task_overdue: true,
      },
      lastSeenId: 0,

      setPermission: (p) => set({ permission: p }),

      setPref: (type, enabled) =>
        set((state) => ({
          prefs: { ...state.prefs, [type]: enabled },
        })),

      setLastSeenId: (id) => set({ lastSeenId: id }),

      requestPermission: async () => {
        if (typeof window === 'undefined' || !('Notification' in window)) {
          return
        }
        try {
          const result = await Notification.requestPermission()
          set({ permission: result })
        } catch {
          // Browser denied or does not support the Permissions API
          set({ permission: 'denied' })
        }
      },
    }),
    {
      name: 'opsnest-notif-prefs',
      partialize: (state) => ({
        prefs: state.prefs,
        lastSeenId: state.lastSeenId,
      }),
    },
  ),
)
